import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import withStyles from "material-ui/styles/withStyles";
import { auth, db } from '../../../firebase/';

import Button from "components/CustomButtons/Button.jsx";
import GridItemHome from "components/Grid/GridItemHome.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInputRegister from "components/CustomInput/CustomInputRegister.jsx";
import { Email, Face, Lock } from "@material-ui/icons";

import InputAdornment from "material-ui/Input/InputAdornment";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";


const INITIAL_STATE = {
            username: '',
            email: '',
            passwordOne: '', 
            passwordTwo: '', 
        formIsValid: true,
        error: null,
    };

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});    

class RegisterForm extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = (event) => {
    const {
        username,
        email,
        passwordOne
        } = this.state;

    const { history } = this.props;   

    auth.doCreateUserWithEmailAndPassword(email, passwordOne)
      .then(authUser => {
          // Create a user in your own accessible Firebase Database too
        db.doCreateUser(authUser.user.uid, username, email)
          .then(() => {
            this.setState(() => ({ ...INITIAL_STATE }));
            history.push( '/projectsea' );
          })
          .catch(error => {
            this.setState(byPropKey('error', error));
          });
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
    }

    checkValidity(value, rules) {
        let isValid = true;
        if (!rules) {
            return true;
        }
        
        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid
        }

        if (rules.isEmail) {
            const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            isValid = pattern.test(value) && isValid
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid
        }

        return isValid;
    }


    render () {
        const {
        username,
        email,
        passwordOne,
        passwordTwo,
        error
        } = this.state;
        
        const { classes } = this.props;

        const isInvalid =
          passwordOne !== passwordTwo ||
          passwordOne === '' ||
          email === '' ||
          username === '';

        let button = (<Button onClick={this.onSubmit} block color="success" size="md" disabled={isInvalid}>
                          Join
                    </Button>);

        return (
            <GridItemHome>
                <form className={classes.form}>
                <CardBody>
                            <CustomInputRegister
                                labelText="Your Name"
                                id="name"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                type: "text",
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Face className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={username}
                                onChange={event => this.setState(byPropKey('username', event.target.value))} />
                            <CustomInputRegister
                                labelText="Email"
                                id="email"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                type: "text",
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Email className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={email}
                                onChange={event => this.setState(byPropKey('email', event.target.value))} />
                            <CustomInputRegister
                                labelText="Your Password"
                                id="passwordOne"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                type: "password",
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Lock className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={passwordOne}
                                onChange={event => this.setState(byPropKey('passwordOne', event.target.value))} />
                            <CustomInputRegister
                                labelText="Type your password again"
                                id="passwordTwo"
                                formControlProps={{
                                fullWidth: true
                                }}
                                inputProps={{
                                type: "password",
                                endAdornment: (
                                <InputAdornment position="end">
                                  <Lock className={classes.inputIconsColor}/>
                                </InputAdornment>
                                )
                                }}
                                value={passwordTwo}
                                onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))} />
                        </CardBody>
                    </form>
                { error && <p className={classes.error}>{error.message}</p> }
                <CardFooter className={classes.cardFooter}>
                    {button}
                </CardFooter>
                <p className={classes.textCenter}>Joined already? <Button
                href="/projectlogin"
                // href="#" 
                color="info" 
                simple
                >Sign In here</Button></p>
            </GridItemHome>
        );
    }
}


export default withRouter(withStyles(componentsStyle)(RegisterForm));


// WEBPACK FOOTER //
// ./src/views/ProjectJoinPage/Sections/RegisterForm.jsx